import { useState } from "react";

import { usePackagesToSignEvents } from "@/components/features/ToDos/PackagesToSignPage/usePackagesToSignEvents";
import { packageApi } from "@/shared/apis";

type UseConnectiveUrlProps = { pkg: MyBrokerApi.DocumentsPackageToSign };

const useConnectiveUrl = ({ pkg }: UseConnectiveUrlProps) => {
    const packagesToSignEvents = usePackagesToSignEvents();
    const [isLoading, setIsLoading] = useState(false);

    const handleSignButtonClick = async () => {
        packagesToSignEvents.packagesToSignProgressed();
        setIsLoading(true);
        await packageApi.getConnectiveUrl(pkg.guid).then((res) => {
            setIsLoading(false);
            window.location.href = res.url;
        });
    };

    return {
        connectiveUrlLoading: isLoading,
        connectiveUrlClicked: handleSignButtonClick,
    };
};

export default useConnectiveUrl;
